import classNames from 'classnames';
import { FallbackProps } from 'react-error-boundary';
import { Button } from 'yoso';
import { ErrorMessage } from '~/components/Error/Message';
import { t } from '~/components/I18n';
import { UnauthorizedStatusBar } from '~/components/Status/Bar/Unauthorized/UnauthorizedStatusBar';
import styles from './StatusBarErrorFallback.module.scss';

export type StatusBarErrorFallbackProps = FallbackProps & {
  className?: string;
};

export const StatusBarErrorFallback = ({ error, className }: StatusBarErrorFallbackProps) => {
  switch (error.message) {
    case 'UNAUTHORIZED':
      return <UnauthorizedStatusBar className={className} />;
    default:
      return (
        // TDOO: use v2 ErrorMessage when other fallbacks in EvolvePage are ready.
        <ErrorMessage
          className={classNames(styles.message, className)}
          title={t('citizen_error_etc_title')}
          description={t('citizen_error_etc_desc')}>
          <Button as="a" href="/" size="large" color="secondary">
            {t('citizen_homebutton')}
          </Button>
        </ErrorMessage>
      );
  }
};
